"use client";
import * as React from "react";
const SvgChangeRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m.73 12.92a.4.4 0 0 1-.68-.28V12H8a4 4 0 0 1-2.83-1.17 4 4 0 0 1-.91-4.24.6.6 0 0 1 .99-.2.6.6 0 0 1 .13.66 2.8 2.8 0 0 0 .64 2.94c.56.56 1.3.83 2.04.81v-.75a.4.4 0 0 1 .68-.28l1.3 1.3a.4.4 0 0 1 0 .56zm2.02-3.3a.6.6 0 0 1-.13-.66 2.8 2.8 0 0 0-.64-2.94 2.8 2.8 0 0 0-2.03-.82v.75a.4.4 0 0 1-.68.28l-1.3-1.29a.4.4 0 0 1 0-.56l1.3-1.3a.4.4 0 0 1 .67.28v.65a4 4 0 0 1 2.88 1.16 4 4 0 0 1 .92 4.24.6.6 0 0 1-.99.2" }));
export {
  SvgChangeRound as default
};
